import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation,
  OnInit,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { ToolbarDropdownOption } from '@zipari/shared-ds-util-navigation';

@Component({
  selector: 'dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DropdownComponent implements OnChanges, OnInit {
  @Input() options: ToolbarDropdownOption[];
  @Input() set value(value: string) {
    this.valueControl.setValue(value);
  }
  @Input() isMobileView = false;
  @Input() displayProperty: string;
  @Input() key: string;
  @Input() disabled: boolean;
  @Input() selectTriggerIcon: string;
  @Input() selectTriggerIconPosition: 'left' | 'right' = 'left';
  @Output() selectOption = new EventEmitter<ToolbarDropdownOption>();
  public valueControl = new UntypedFormControl(null);
  public openerLabel: string;

  ngOnInit(): void {
    this.disabled && this.valueControl.disable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hasChanges = this.hasEntryChanges(changes, [
      'options',
      'value',
      'displayProperty',
      'key',
    ]);

    if (hasChanges) {
      this.openerLabel = this.getOpenerLabel(this.valueControl.value);
    }
  }

  public handleOptionsChange(option: MatSelectChange): void {
    const selectedOption = this.getSelectedOption(option.value);

    this.openerLabel = this.getOpenerLabel(option.value);
    this.selectOption.emit(selectedOption);
  }

  public getOpenerLabel(value: string): string {
    const selectedOptions = this.getSelectedOption(value);

    return selectedOptions?.[this.displayProperty] || '';
  }

  private getSelectedOption(value: string): ToolbarDropdownOption {
    return this.options?.find((lang) => lang[this.key] === value);
  }

  private hasEntryChanges(
    changes: SimpleChanges,
    properties: string[],
  ): boolean {
    return properties.some(
      (prop) => changes[prop]?.currentValue !== changes[prop]?.previousValue,
    );
  }
}
